import {
  MAIN_TABS,
  PHONE_TABS,
  MESSAGES_TABS,
  SETTINGS_TABS,
} from "@/communications/constants";

export const types = {
  // UI State
  COMMUNICATIONS_SET_EXPANDED: "COMMUNICATIONS_SET_EXPANDED",
  COMMUNICATIONS_SET_ACTIVE_MAIN_TAB: "COMMUNICATIONS_SET_ACTIVE_MAIN_TAB",
  COMMUNICATIONS_SET_ACTIVE_COMMUNICATIONS_TAB:
    "COMMUNICATIONS_SET_ACTIVE_COMMUNICATIONS_TAB",
  COMMUNICATIONS_SET_ACTIVE_MESSAGES_TAB:
    "COMMUNICATIONS_SET_ACTIVE_MESSAGES_TAB",
  COMMUNICATIONS_SET_ACTIVE_SETTINGS_TAB:
    "COMMUNICATIONS_SET_ACTIVE_SETTINGS_TAB",
  COMMUNICATIONS_SET_SELECTED_CALL_LOG: "COMMUNICATIONS_SET_SELECTED_CALL_LOG",
  COMMUNICATIONS_SET_SELECTED_CONVERSATION:
    "COMMUNICATIONS_SET_SELECTED_CONVERSATION",
  COMMUNICATIONS_TRIGGER_CALL_LOGS_REFRESH:
    "COMMUNICATIONS_TRIGGER_CALL_LOGS_REFRESH",

  // Call State
  COMMUNICATIONS_SET_COMMUNICATIONS_NUMBER:
    "COMMUNICATIONS_SET_COMMUNICATIONS_NUMBER",
  COMMUNICATIONS_SET_CALLER_ID: "COMMUNICATIONS_SET_CALLER_ID",
  COMMUNICATIONS_SET_CONNECTED: "COMMUNICATIONS_SET_CONNECTED",
  COMMUNICATIONS_SET_CONNECTING: "COMMUNICATIONS_SET_CONNECTING",
  COMMUNICATIONS_SET_MUTED: "COMMUNICATIONS_SET_MUTED",
  COMMUNICATIONS_SET_PLAYING_AUDIO: "COMMUNICATIONS_SET_PLAYING_AUDIO",
  COMMUNICATIONS_SET_PENDING_CALL: "COMMUNICATIONS_SET_PENDING_CALL",
  COMMUNICATIONS_RESET_CALL: "COMMUNICATIONS_RESET_CALL",
  COMMUNICATIONS_SET_CALL_IDI_PERSON_ID:
    "COMMUNICATIONS_SET_CALL_IDI_PERSON_ID",
  COMMUNICATIONS_SET_CALL_OWNER_ID: "COMMUNICATIONS_SET_CALL_OWNER_ID",
  COMMUNICATIONS_SET_CURRENT_CALL_SID: "COMMUNICATIONS_SET_CURRENT_CALL_SID",
  COMMUNICATIONS_SET_DIALER_NOTES: "COMMUNICATIONS_SET_DIALER_NOTES",
  COMMUNICATIONS_SET_DIALED_DIGITS: "COMMUNICATIONS_SET_DIALED_DIGITS",

  // Audio Device State
  COMMUNICATIONS_SET_INPUT_DEVICES: "COMMUNICATIONS_SET_INPUT_DEVICES",
  COMMUNICATIONS_SET_OUTPUT_DEVICES: "COMMUNICATIONS_SET_OUTPUT_DEVICES",
  COMMUNICATIONS_SET_SELECTED_INPUT_DEVICE:
    "COMMUNICATIONS_SET_SELECTED_INPUT_DEVICE",
  COMMUNICATIONS_SET_SELECTED_OUTPUT_DEVICE:
    "COMMUNICATIONS_SET_SELECTED_OUTPUT_DEVICE",
  COMMUNICATIONS_SET_LOADING_DEVICES: "COMMUNICATIONS_SET_LOADING_DEVICES",
  COMMUNICATIONS_SET_PREFERRED_DEVICES: "COMMUNICATIONS_SET_PREFERRED_DEVICES",
  COMMUNICATIONS_SET_DEVICE_STATUS: "COMMUNICATIONS_SET_DEVICE_STATUS",

  // Audio Test State
  COMMUNICATIONS_SET_TESTING_AUDIO: "COMMUNICATIONS_SET_TESTING_AUDIO",
  COMMUNICATIONS_SET_TEST_RESULTS: "COMMUNICATIONS_SET_TEST_RESULTS",
  COMMUNICATIONS_RESET_TEST: "COMMUNICATIONS_RESET_TEST",
};

// ==========================================
// UI Actions
// ==========================================
export const setExpanded = (value) => ({
  type: types.COMMUNICATIONS_SET_EXPANDED,
  value,
});

export const setActiveMainTab = (value) => ({
  type: types.COMMUNICATIONS_SET_ACTIVE_MAIN_TAB,
  value,
});

export const setActivePhoneTab = (value) => ({
  type: types.COMMUNICATIONS_SET_ACTIVE_COMMUNICATIONS_TAB,
  value,
});

export const setActiveMessagesTab = (value) => ({
  type: types.COMMUNICATIONS_SET_ACTIVE_MESSAGES_TAB,
  value,
});

export const setActiveSettingsTab = (value) => ({
  type: types.COMMUNICATIONS_SET_ACTIVE_SETTINGS_TAB,
  value,
});

export const setSelectedCallLog = (value) => ({
  type: types.COMMUNICATIONS_SET_SELECTED_CALL_LOG,
  value,
});

export const setSelectedConversation = (value) => ({
  type: types.COMMUNICATIONS_SET_SELECTED_CONVERSATION,
  value,
});

export const triggerCallLogsRefresh = () => ({
  type: types.COMMUNICATIONS_TRIGGER_CALL_LOGS_REFRESH,
});

// ==========================================
// Call Actions
// ==========================================
export const setPhoneNumber = (value) => ({
  type: types.COMMUNICATIONS_SET_COMMUNICATIONS_NUMBER,
  value,
});

export const setCallerId = (value) => ({
  type: types.COMMUNICATIONS_SET_CALLER_ID,
  value,
});

export const setConnected = (value) => ({
  type: types.COMMUNICATIONS_SET_CONNECTED,
  value,
});

export const setConnecting = (value) => ({
  type: types.COMMUNICATIONS_SET_CONNECTING,
  value,
});

export const setMuted = (value) => ({
  type: types.COMMUNICATIONS_SET_MUTED,
  value,
});

export const setPlayingAudio = (value) => ({
  type: types.COMMUNICATIONS_SET_PLAYING_AUDIO,
  value,
});

export const setPendingCall = (value) => ({
  type: types.COMMUNICATIONS_SET_PENDING_CALL,
  value,
});

export const setCallIdiPersonId = (value) => ({
  type: types.COMMUNICATIONS_SET_CALL_IDI_PERSON_ID,
  value,
});

export const setCallOwnerId = (value) => ({
  type: types.COMMUNICATIONS_SET_CALL_OWNER_ID,
  value,
});

export const setCurrentCallSid = (value) => ({
  type: types.COMMUNICATIONS_SET_CURRENT_CALL_SID,
  value,
});

export const resetCall = () => ({
  type: types.COMMUNICATIONS_RESET_CALL,
});

export const setDialerNotes = (value) => ({
  type: types.COMMUNICATIONS_SET_DIALER_NOTES,
  value,
});

export const setDialedDigits = (value) => ({
  type: types.COMMUNICATIONS_SET_DIALED_DIGITS,
  value,
});

// ==========================================
// Audio Device Actions
// ==========================================
export const setInputDevices = (value) => ({
  type: types.COMMUNICATIONS_SET_INPUT_DEVICES,
  value,
});

export const setOutputDevices = (value) => ({
  type: types.COMMUNICATIONS_SET_OUTPUT_DEVICES,
  value,
});

export const setSelectedInputDevice = (value) => ({
  type: types.COMMUNICATIONS_SET_SELECTED_INPUT_DEVICE,
  value,
});

export const setSelectedOutputDevice = (value) => ({
  type: types.COMMUNICATIONS_SET_SELECTED_OUTPUT_DEVICE,
  value,
});

export const setLoadingDevices = (value) => ({
  type: types.COMMUNICATIONS_SET_LOADING_DEVICES,
  value,
});

export const setPreferredDevices = (value) => ({
  type: types.COMMUNICATIONS_SET_PREFERRED_DEVICES,
  value,
});

// value: { status: "unset" | "ok" | "mismatch", mismatch: { input, output } }
export const setDeviceStatus = (value) => ({
  type: types.COMMUNICATIONS_SET_DEVICE_STATUS,
  value,
});

// ==========================================
// Audio Test Actions
// ==========================================
export const setTestingAudio = (value) => ({
  type: types.COMMUNICATIONS_SET_TESTING_AUDIO,
  value,
});

export const setTestResults = (value) => ({
  type: types.COMMUNICATIONS_SET_TEST_RESULTS,
  value,
});

export const resetTest = () => ({
  type: types.COMMUNICATIONS_RESET_TEST,
});

// ==========================================
// Initial State
// ==========================================
export const initialState = {
  // UI State
  isExpanded: false,
  activeMainTab: MAIN_TABS.CALLS,
  activePhoneTab: PHONE_TABS.DIALPAD,
  activeMessagesTab: MESSAGES_TABS.NEW,
  activeSettingsTab: SETTINGS_TABS.AUDIO,
  selectedCallLog: null,
  selectedConversation: null,
  callLogsRefreshTrigger: 0,

  // Call State
  phoneNumber: "",
  selectedCallerId: null,
  isConnected: false,
  isConnecting: false,
  isMuted: false,
  isPlayingAudio: false,
  pendingCall: false,
  callIdiPersonId: null,
  callOwnerId: null,
  currentCallSid: null,
  dialerNotes: "",
  dialedDigits: "",

  // Audio Device State
  inputDevices: [],
  outputDevices: [],
  selectedInputDevice: null,
  selectedOutputDevice: null,
  loadingDevices: false,
  // Preferred devices live in localStorage (utils/audioDevices.js); this is
  // the loaded copy plus how the current device list measures up to it.
  // deviceStatus is null until the Twilio device has enumerated devices.
  preferredDevices: null,
  deviceStatus: null,
  deviceMismatch: { input: null, output: null },

  // Audio Test State
  isTestingAudio: false,
  testResults: null,
};

// ==========================================
// Reducer
// ==========================================
export function reducer(state = initialState, action) {
  const { type, value } = action;

  switch (type) {
    // UI State
    case types.COMMUNICATIONS_SET_EXPANDED:
      return { ...state, isExpanded: value };
    case types.COMMUNICATIONS_SET_ACTIVE_MAIN_TAB:
      return { ...state, activeMainTab: value };
    case types.COMMUNICATIONS_SET_ACTIVE_COMMUNICATIONS_TAB:
      return { ...state, activePhoneTab: value };
    case types.COMMUNICATIONS_SET_ACTIVE_MESSAGES_TAB:
      return { ...state, activeMessagesTab: value };
    case types.COMMUNICATIONS_SET_ACTIVE_SETTINGS_TAB:
      return { ...state, activeSettingsTab: value };
    case types.COMMUNICATIONS_SET_SELECTED_CALL_LOG:
      return { ...state, selectedCallLog: value };
    case types.COMMUNICATIONS_SET_SELECTED_CONVERSATION:
      return { ...state, selectedConversation: value };
    case types.COMMUNICATIONS_TRIGGER_CALL_LOGS_REFRESH:
      return {
        ...state,
        callLogsRefreshTrigger: state.callLogsRefreshTrigger + 1,
      };

    // Call State
    case types.COMMUNICATIONS_SET_COMMUNICATIONS_NUMBER:
      return { ...state, phoneNumber: value };
    case types.COMMUNICATIONS_SET_CALLER_ID:
      return { ...state, selectedCallerId: value };
    case types.COMMUNICATIONS_SET_CONNECTED:
      return { ...state, isConnected: value };
    case types.COMMUNICATIONS_SET_CONNECTING:
      return { ...state, isConnecting: value };
    case types.COMMUNICATIONS_SET_MUTED:
      return { ...state, isMuted: value };
    case types.COMMUNICATIONS_SET_PLAYING_AUDIO:
      return { ...state, isPlayingAudio: value };
    case types.COMMUNICATIONS_SET_PENDING_CALL:
      return { ...state, pendingCall: value };
    case types.COMMUNICATIONS_SET_CALL_IDI_PERSON_ID:
      return { ...state, callIdiPersonId: value };
    case types.COMMUNICATIONS_SET_CALL_OWNER_ID:
      return { ...state, callOwnerId: value };
    case types.COMMUNICATIONS_SET_CURRENT_CALL_SID:
      return { ...state, currentCallSid: value };
    case types.COMMUNICATIONS_SET_DIALER_NOTES:
      return { ...state, dialerNotes: value };
    case types.COMMUNICATIONS_SET_DIALED_DIGITS:
      return { ...state, dialedDigits: value };
    case types.COMMUNICATIONS_RESET_CALL:
      return {
        ...state,
        isConnected: false,
        isConnecting: false,
        isMuted: false,
        isPlayingAudio: false,
        pendingCall: false,
        callIdiPersonId: null,
        callOwnerId: null,
        currentCallSid: null,
        dialedDigits: "",
      };

    // Audio Device State
    case types.COMMUNICATIONS_SET_INPUT_DEVICES:
      return { ...state, inputDevices: value };
    case types.COMMUNICATIONS_SET_OUTPUT_DEVICES:
      return { ...state, outputDevices: value };
    case types.COMMUNICATIONS_SET_SELECTED_INPUT_DEVICE:
      return { ...state, selectedInputDevice: value };
    case types.COMMUNICATIONS_SET_SELECTED_OUTPUT_DEVICE:
      return { ...state, selectedOutputDevice: value };
    case types.COMMUNICATIONS_SET_LOADING_DEVICES:
      return { ...state, loadingDevices: value };
    case types.COMMUNICATIONS_SET_PREFERRED_DEVICES:
      return { ...state, preferredDevices: value };
    case types.COMMUNICATIONS_SET_DEVICE_STATUS:
      return {
        ...state,
        deviceStatus: value.status,
        deviceMismatch: value.mismatch || { input: null, output: null },
      };

    // Audio Test State
    case types.COMMUNICATIONS_SET_TESTING_AUDIO:
      return { ...state, isTestingAudio: value };
    case types.COMMUNICATIONS_SET_TEST_RESULTS:
      return { ...state, testResults: value };
    case types.COMMUNICATIONS_RESET_TEST:
      return { ...state, isTestingAudio: false, testResults: null };

    default:
      return state;
  }
}

// ==========================================
// Export Actions
// ==========================================
const actions = {
  // UI
  setExpanded,
  setActiveMainTab,
  setActivePhoneTab,
  setActiveMessagesTab,
  setActiveSettingsTab,
  setSelectedCallLog,
  setSelectedConversation,
  triggerCallLogsRefresh,
  // Call
  setPhoneNumber,
  setCallerId,
  setConnected,
  setConnecting,
  setMuted,
  setPlayingAudio,
  setPendingCall,
  setCallIdiPersonId,
  setCallOwnerId,
  setCurrentCallSid,
  resetCall,
  setDialerNotes,
  setDialedDigits,
  // Audio Devices
  setInputDevices,
  setOutputDevices,
  setSelectedInputDevice,
  setSelectedOutputDevice,
  setLoadingDevices,
  setPreferredDevices,
  setDeviceStatus,
  // Audio Test
  setTestingAudio,
  setTestResults,
  resetTest,
};

export default actions;
